export class MultipleSocketSubscriptionException extends Error {
    constructor(roomId) {
        super(`Room ${roomId} has already been subscribed before, enable multiple concurrenct room subscription or keep just one`);
    }
}
//# sourceMappingURL=MultipleSocketSubscriptionException.js.map